import React from "react";
import _ from "lodash";
import { FormRenderSchemaConfig } from "../types/FormRendererConfig";
import { DecisionEvaluator } from "../DecisionEvaluator";
import RenderFieldFromSchemaWrapper from "./RenderFieldFromSchema";
import { SchemaField } from "../types/SchemaField";
import { DISPLAY_ORDER_KEY } from "shared/utils/constants";

/**
 * @name RenderFormFromSchema
 * @interface FormRenderSchemaConfig
 * @param props
 * @constructor
 */
export default function RenderFormFromSchema(props: FormRenderSchemaConfig) {
  const updatedSchemaList: Array<SchemaField> = React.useMemo(() => {
    const updatedList = props.schemaList.filter(schemaObj => {
      return DecisionEvaluator.isFieldVisible({
        formValues: props.formValues,
        schemaObj,
        schemaList: props.schemaList
      });
    });
    return _.sortBy(updatedList, DISPLAY_ORDER_KEY);
  }, [props.schemaList, props.formValues]);

  return (
    <React.Fragment>
      {updatedSchemaList.map(schemaObj => (
        <RenderFieldFromSchemaWrapper
          key={schemaObj.id}
          formValues={props.formValues}
          schemaList={props.schemaList}
          schemaObj={schemaObj}
        />
      ))}
    </React.Fragment>
  );
}
